import * as types from "./constants";

const initialState = {
  roles: [],
  searchValue: "",
  searchValueOnClick: "",
  overlayIsShowing: false,
  roleName: "",
  roleLevel: null,
  currentRole: null,
  currentRoleLevel: null,
  rolesLoading: false,
};

const roleReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_ROLES:
      return {
        ...state,
        roles: action.roles,
      };
    case types.SET_SEARCH_VALUE:
      return {
        ...state,
        searchValue: action.searchValue,
      };
    case types.SET_SEARCH_VALUE_ON_CLICK:
      return {
        ...state,
        searchValueOnClick: action.value,
      };
    case types.TOGGLE_OVERLAY:
      return {
        ...state,
        overlayIsShowing: !state.overlayIsShowing,
      };
    case types.TOGGLE_EDIT_OVERLAY:
      return {
        ...state,
        editOverlayIsShowing: !state.editOverlayIsShowing,
      };
    case types.SET_ROLE_NAME:
      return {
        ...state,
        roleName: action.value,
      };
    case types.SET_ROLE_LEVEL:
      return {
        ...state,
        roleLevel: action.value,
      };
    case types.SET_CURRENT_ROLE:
      return {
        ...state,
        currentRole: action.value,
      };
    case types.SET_CURRENT_ROLE_NAME:
      return {
        ...state,
        currentRole: {
          ...state.currentRole,
          name: action.value,
        },
      };
    case types.SET_CURRENT_ROLE_LEVEL:
      return {
        ...state,
        currentRole: {
          ...state.currentRole,
          level: action.value,
        },
      };
    case types.SET_ROLES_LOADING:
      return {
        ...state,
        rolesLoading: action.value,
      };
    default:
      return state;
  }
};
export default roleReducer;
